<template>
  <main-layout :title="$t('My Businesses')">
    <template v-slot:titleActions>
      <guide-help-button guide-name="businesses" class="ml-3" />
    </template>
    <template v-slot:body>
      <places-table />
    </template>
  </main-layout>
</template>

<script>
import MetaTitleMixin from '@/lib/MetaTitleMixin';
import PlacesTable from '@/components/tables/PlacesTable.vue';
import GuideHelpButton from '@/components/GuideHelpButton.vue';

export default {
  mixins: [MetaTitleMixin],
  components: {
    PlacesTable,
    GuideHelpButton,
  },
  mounted() {
    this.$title = this.$t('Businesses');
  },
};
</script>
